<div class="dialog-container">
  <div flex layout-align="space-between center" layout="row">
    @if (isNewItem) {
      <div class="modal-dialog-title" [translate]="'clients.newBlacklist'" flex>
        Add in blacklist
      </div>
    }
    @if (!isNewItem) {
      <div
        class="modal-dialog-title"
        [translate]="'clients.editBlacklist'"
        flex
      >
        Edit in blacklist
      </div>
    }
    <button tabindex="-1" mat-icon-button (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr />
  <form
    [itfgPermissions]="'BLACKLIST_WRITE'"
    layout="column"
    novalidate
    [formGroup]="blacklistEditForm"
    (ngSubmit)="onSubmit($event)"
    class="form-position-fixing"
  >
    <div flex="100" layout="row" layout-wrap layout-align="center center">
      <div
        flex="100"
        layout="row"
        layout-wrap
        layout-align="space-around center"
      >
        <mat-form-field flex class="edit-blacklist-aditional-padding">
          @if (!isPreset) {
            <mat-select
              required
              matInput
              formControlName="blacklistType"
              (selectionChange)="selectedValueChanged()"
              placeholder="{{ 'clients.chooseType' | translate }}"
            >
              @for (blacklistType of blacklistTypes; track blacklistType) {
                <mat-option
                  [disabled]="['BLACKLIST_WRITE'] | isUnauthorized | async"
                  [value]="blacklistType.id"
                  >{{ blacklistType.name }}</mat-option
                >
              }
            </mat-select>
          }
          @if (isPreset) {
            <input
              readonly
              matInput
              value="{{
                blacklistTypes[
                  blacklistEditForm?.get('blacklistType')?.value - 1
                ]?.name
              }}"
              formControlName="blacklistType"
            />
          }
        </mat-form-field>

        <mat-form-field flex class="edit-blacklist-aditional-padding">
          <mat-label>{{ 'global.brand' | translate }}</mat-label>
          <mat-select
            #brandInput
            formControlName="selectedBrand"
            required
            [compareWith]="compareBrands"
            disableOptionCentering="true"
          >
            <mat-option [value]="allBrandsOption">
              <div layout="row" layout-align="start center" layout-gap="8px">
                <mat-icon fontIcon="public"></mat-icon>
                <span>{{ 'brands.allBrands' | translate }}</span>
              </div>
            </mat-option>
            @for (brand of brands; track brand.id) {
              <mat-option [value]="brand">
                <div layout="row" layout-align="start center" layout-gap="8px">
                  <itfg-brand-logo
                    [brand]="brand"
                    size="'20px'"
                  ></itfg-brand-logo>
                  <span>{{ brand.name }}</span>
                </div>
              </mat-option>
            }
          </mat-select>
          @if (blacklistEditForm.get('selectedBrand')?.hasError('required')) {
            <mat-error [translate]="'forms.required'">required</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          flex
          class="edit-blacklist-aditional-padding"
          layout="row"
        >
          <input
            matInput
            readonly="true"
            formControlName="expire"
            [matDatepicker]="picker"
            [min]="currentDate"
            placeholder="{{ 'clients.expire' | translate }}"
          />
          <mat-label>{{ 'clients.expire' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="blacklistEditForm.get('expire')"
          ></itfg-form-control-clear>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker [touchUi]="isMobile()" #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        flex="100"
        layout="row"
        layout-wrap
        layout-align="space-between center"
      >
        <mat-form-field flex class="edit-blacklist-aditional-padding">
          <input
            type="text"
            matInput
            formControlName="notes"
            placeholder="{{ 'clients.notes' | translate }}"
          />
          <mat-label>{{ 'clients.notes' | translate }}</mat-label>
        </mat-form-field>
      </div>
      <div flex="100" layout="row">
        <mat-form-field flex="100" class="edit-blacklist-aditional-padding">
          <textarea
            [readonly]="isPreset"
            matInput
            required
            formControlName="value"
            placeholder="{{
              gridSecondColumnTranslations[selectedBlacklistType] | translate
            }}"
            (paste)="bulkAddPaste($event)"
          >
          </textarea>
          @if (blacklistFormArr.hasError('required')) {
            <mat-error [translate]="'forms.required'">required</mat-error>
          }
          @if (invalidValues && blacklistFormArr.invalid) {
            <mat-hint [ngStyle]="{ color: '#d32f2f' }"
              >{{ 'clients.blacklistImportInvalid' | translate
              }}{{ invalidValues }}</mat-hint
            >
          }
        </mat-form-field>
      </div>
    </div>
    <div
      class="dialog-bottom-nav-bar edit-blacklist-aditional-padding"
      flex="100"
      layout="row"
      layout-align="end center"
    >
      <button
        mat-raised-button
        type="submit"
        flex-offset="80"
        flex="20"
        class="save-button"
      >
        {{ 'global.save' | translate }}
      </button>
      @if (blacklistEditData?.id) {
        <button
          mat-raised-button
          type="button"
          (click)="deleteFromBlackList()"
          flex-offset="80"
          flex="20"
        >
          <span class="mat-button-wrapper">{{
            'global.delete' | translate
          }}</span>
        </button>
      }
    </div>
  </form>
</div>
